'use strict';

module.exports = {
  CONTAINER_HEIGHT_SCALE_FACTOR: 'containerHeightScaleFactor'
};


//////////////////
// WEBPACK FOOTER
// ./~/react-infinite/build/utils/scaleEnum.js
// module id = 640
// module chunks = 0